import React from 'react'
import styled from 'styled-components'
import {Icon, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {GiftShopTemplateOptionsItemProps} from './GiftShopTemplateOptionsProps'

const StyledContainer = styled.div`
  padding: ${convertUnit(14)} ${convertUnit(20)};
  gap: ${convertUnit(20)};
  display: flex;
  align-items: center;
  cursor: pointer;
`

export default function GiftShopTemplateOptionsItem({
  icon,
  text,
  color,
  onClickItem,
}: GiftShopTemplateOptionsItemProps) {
  return (
    <StyledContainer onClick={onClickItem}>
      <Icon type={icon} color={color} />
      <Paragraph fontSize="m" fontWeight="medium" color={color}>
        {text}
      </Paragraph>
    </StyledContainer>
  )
}
